<template lang="html">
<div class="invoices">
  <row>
    <div class="sl-col-4">
      <div class="sl-condition">
        <row>
          <div class="col-md-4">
            <div class="form-group">
              <el-date-picker v-model="datePicker" type="month" :placeholder="$t('Date.placeholder')"></el-date-picker>
            </div>
          </div>
          <div class="col-md-4 sm-margin">
            <div class="form-group">
              <sl-btn class="sl-btn-lightblue" :text="$t('Functional.confirm')" @click.native="searchByCondition"></sl-btn>
            </div>
          </div>
        </row>
      </div>
    </div>
  </row>
  <row>
    <div class="sl-col-4">
      <div class="sl-body" v-loading="loading">
        <row class="sl-table-reload" v-show="reloadBtn">
          {{$t('Notify.errorMsg')}}
          <sl-btn class="sl-btn-lightblue" :text="$t('Functional.reload')" @click.native="reloadTable"></sl-btn>
        </row>
        <el-table :data="tableData" style="width: 100%" @sort-change="handleSortChange" border>
          <el-table-column min-width="200" :show-overflow-tooltip="true" prop="createMonth" :label="$t('Views.Invoices.month')" sortable="custom"> </el-table-column>
          <el-table-column min-width="200" :show-overflow-tooltip="true" prop="amount" :label="$t('Views.Invoices.amount')" sortable="custom"> </el-table-column>
          <el-table-column min-width="200" :show-overflow-tooltip="true" prop="GST" :label="$t('Views.Invoices.gst')"> </el-table-column>
          <el-table-column min-width="200" :show-overflow-tooltip="true" prop="totalAmount" :label="$t('Views.Invoices.tAmount')"> </el-table-column>
          <el-table-column min-width="200" :show-overflow-tooltip="true" prop="invoiceNo" :label="$t('Views.Invoices.in')"> </el-table-column>
          <el-table-column :min-width="$store.state.userAgent.isPhone ? 100 : 200" fixed="right" :label="$t('Table.actions')">
            <template scope="scope">
              <a class="sl-edit" :href="`/client/invoice/${scope.row.invoiceNo}`" download="FileName" @click="$ga.event('Button', 'Download', 'Invoices')">{{$t('Functional.download')}}</a>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination v-show="!reloadBtn" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="table.page" :page-sizes="[10, 20, 50, 100]" :page-size="table.per" layout="prev, pager, next, sizes,jumper,total" :total="table.total"> </el-pagination>
      </div>
    </div>
  </row>
</div>
</template>
<script>
import api from '../../../api'
import moment from '../../../util/date'
import * as types from '../../../store/types'
export default {
  name: 'Accounts',
  data() {
    return {
      loading: false,
      tableData: [],
      table: this.$store.state.invoices.table,
      condition: this.$store.state.invoices.condition,
      datePicker: '',
      reloadBtn: false
    }
  },
  methods: {
    formatterAdmin(row, column) {
      return row.admin === '1' ? this.$tc('Functional.yes', 2) : this.$tc('Functional.no', 2)
    },
    filterStatus(value, row) {
      return row.status === value
    },
    handleSizeChange(per) {
      this.table.per = per
      updateTable(this, initParams(this))
    },
    handleCurrentChange(page) {
      this.table.page = page
      updateTable(this, initParams(this))
    },
    handleSortChange({
      column,
      prop,
      order
    }) {
      this.table = {
        page: this.table.page,
        per: this.table.per,
        order: order === null ? '' : order === 'descending' ? 'DESC' : 'ASC',
        orderBy: prop === null ? '' : prop
      }
      updateTable(this, initParams(this))
    },
    searchByCondition() {
      this.$ga.event('Button', 'TableSearch', 'Invoices')
      updateTable(this, initParams(this))
    },
    reloadTable() {
      this.$ga.event('Button', 'Reload', 'Invoices')
      updateTable(this, initParams(this))
    }
  },
  created() {
    updateTable(this, initParams(this))
  },
  beforeRouteLeave(to, from, next) {
    next()
  }
}
// 更新表单 。 默认每页10条，页码为1
function updateTable(vm, params) {
  vm.loading = true
  api.FetchInvoiceTable(params).then(res => {
    const result = res.data.data
    vm.table = {
      total: result.total,
      page: ~~result.page,
      per: ~~result.per
    }
    vm.tableData = result.list
    vm.reloadBtn = vm.loading = false
  }).catch(error => {
    console.log(error)
    vm.tableData = []
    vm.loading = false
    vm.reloadBtn = true
  })
}
// 初始化table请求接口的参数
function initParams(vm) {
  vm.$store.commit(types.SetInvoiceTable, {
    table: Object.assign({}, vm.table),
    condition: Object.assign({}, vm.condition)
  })
  const ts = Object.assign({}, vm.$store.state.invoices)
  let tb = JSON.parse(JSON.stringify(ts.table))
  let cd = JSON.parse(JSON.stringify(ts.condition))
  delete tb.total
  cd.month = vm.datePicker === '' ? '' : moment(vm.datePicker).format('MM/YYYY')
  return Object.assign({}, tb, cd)
}
</script>
<style>
.invoices div.sl-body td .cell.el-tooltip {
  white-space: nowrap;
  word-break: break-all;
  text-overflow: ellipsis;
  width: 200px;
}

.invoices div.sl-body th .cell {
  white-space: nowrap;
  word-break: break-all;
  text-overflow: ellipsis;
  width: 200px;
}

.invoices .el-date-editor.el-input {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// invoices.vue?8d9b198c